export const DEFAULT_PROFILE_TAG_COLOR = '#e5e7eb';

const HEX_COLOR_PATTERN = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const WCAG_LUMINANCE_THRESHOLD = 0.179;

export function normalizeProfileTagColor(hex) {
  const match = HEX_COLOR_PATTERN.exec(hex || '');
  if (!match) return DEFAULT_PROFILE_TAG_COLOR;

  const value = match[1].toLowerCase();
  if (value.length === 3) {
    return `#${value.split('').map((digit) => digit + digit).join('')}`;
  }

  return `#${value}`;
}

export function getProfileTagTextColor(hex) {
  const normalizedHex = normalizeProfileTagColor(hex);
  const rgb = [
    parseInt(normalizedHex.slice(1, 3), 16) / 255,
    parseInt(normalizedHex.slice(3, 5), 16) / 255,
    parseInt(normalizedHex.slice(5, 7), 16) / 255,
  ];
  const [r, g, b] = rgb.map((channel) =>
    channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4),
  );
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance > WCAG_LUMINANCE_THRESHOLD ? '#000000' : '#ffffff';
}
